import { MessageMap } from "@plex/culture-core";

import { cacheApi } from "config";
import { getClientFor } from "infrastructure/http";

export interface ITranslationMessagesGetRequest {
  messagePrefix: string;
  locale: string;
  noCache: boolean;
  lastModified?: Date;
}

export interface ITranslationMessagesGetResponse {
  messages: MessageMap;
  lastModified: Date;
  messagePrefix: string;
}

export const getTranslationMessages = async (parameters: ITranslationMessagesGetRequest) => {
  const config = {
    headers: {
      "Accept-Language": parameters.locale
    }
  };

  if (parameters.noCache) {
    config.headers["Cache-Control"] = "no-cache";
  } else if (parameters.lastModified) {
    config.headers["Last-Modified"] = new Date(parameters.lastModified).toUTCString();
  }

  const response = await getClientFor(cacheApi.name).get<MessageMap>("/v1/messages/" + encodeURIComponent(parameters.messagePrefix), config);

  const data: ITranslationMessagesGetResponse = {
    messages: response.data,
    lastModified: new Date(response.headers["last-modified"]),
    messagePrefix: parameters.messagePrefix
  };

  return data;
};
